

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */
import $ from 'jquery';

import local_pkcs11_handler from './local_pkcs11_handler';
import mobile_qr_handler from './mobile_qr_handler';

export default $.extend(
    {},
    local_pkcs11_handler,
    mobile_qr_handler,
);
